// API URL
export const API_URL = process.env.REACT_APP_API_URL + '/api'

//permissions
export const permissions = [
    {
        "id": 107,
        "name": "VIEW_DASHBOARD",
        "slug": "View Dashboard",
        "route": "/",
    },
    {
        "id": 108,
        "name": "VIEW_VEHICLES",
        "slug": "View Vehicles",
        "route": "/vehicles",
    },
    {
        "id": 109,
        "name": "ADD_VEHICLE",
        "slug": "Add Vehicle",
        "route": "/vehicles",
    },
    {
        "id": 110,
        "name": "DELETE_VEHICLE",
        "slug": "Delete Vehicle",
        "route": "/vehicles",
    },
    {
        "id": 111,
        "name": "EXPORT_VEHICLE",
        "slug": "Export Vehicle",
        "route": "/vehicles",
    },
    {
        "id": 112,
        "name": "VIEW_CUSTOMERS",
        "slug": "View Customer",
        "route": "/customers",
    },
    {
        "id": 113,
        "name": "ADD_CUSTOMER",
        "slug": "Add Customer",
        "route": "/customers",
    },
    {
        "id": 114,
        "name": "DELETE_CUSTOMER",
        "slug": "Delete Customer",
        "route": "/customers",
    },
    {
        "id": 115,
        "name": "VIEW_VENDORS",
        "slug": "View Vendors",
        "route": "/vendors",
    },
    {
        "id": 116,
        "name": "ADD_VENDOR",
        "slug": "Add Vendor",
        "route": "/vendors",
    },
    {
        "id": 117,
        "name": "DELETE_VENDOR",
        "slug": "Delete Vendor",
        "route": "/vendors",
    },
    {
        "id": 118,
        "name": "VIEW_EMPLOYEES",
        "slug": "View Employees",
        "route": "/employees",
    },
    {
        "id": 119,
        "name": "ADD_EMPLOYEES",
        "slug": "Add Employee",
        "route": "/employees",
    },
    {
        "id": 120,
        "name": "DELETE_EMPLOYEES",
        "slug": "Delete Employee",
        "route": "/employees",
    },
    {
        "id": 121,
        "name": "VIEW_LOADPLANS",
        "slug": "View Load Plans",
        "route": "/container",
    },
    {
        "id": 122,
        "name": "ADD_LOADPLAN",
        "slug": "Add Load Plan",
        "route": "/container",
    },
    {
        "id": 123,
        "name": "DELETE_LOADPLAN",
        "slug": "Delete Load Plan",
        "route": "/container",
    },
    {
        "id": 124,
        "name": "VIEW_INVOICES",
        "slug": "View Invoices",
        "route": "/invoices",
    },
    {
        "id": 125,
        "name": "ADD_INVOICE",
        "slug": "Add Invoice",
        "route": "/invoices",
    },
    {
        "id": 126,
        "name": "DELETE_INVOICE",
        "slug": "Delete Invoice",
        "route": "/invoices",
    },
    {
        "id": 127,
        "name": "APPROVE_INVOICE",
        "slug": "Approve Invoice",
        "route": "/approveInvoice",
    },
    {
        "id": 128,
        "name": "VIEW_BLFORM",
        "slug": "View Bl Form",
        "route": "/blform",
    },
    {
        "id": 129,
        "name": "ADD_BLFORM",
        "slug": "Add Bl Form",
        "route": "/blform",
    },
    {
        "id": 130,
        "name": "DELETE_BLFORM",
        "slug": "Delete Bl Form",
        "route": "/blform",
    },
    {
        "id": 131,
        "name": "VIEW_ACCOUNTS",
        "slug": "View Accounts",
        "route": "/accounts",
    },
    {
        "id": 132,
        "name": "ADD_TRANSACTION",
        "slug": "Add Transaction",
        "route": "/accounts",
    },
    {
        "id": 133,
        "name": "BROWSE_TRANSACTION",
        "slug": "Browse Transaction",
        "route": "/accounts",
    },
    {
        "id": 134,
        "name": "VIEW_LEDGER",
        "slug": "ledger",
        "route": "/accounts/general_ledger",
    },
    {
        "id": 135,
        "name": "VIEW_APPOINTMENTS",
        "slug": "View Appointment",
        "route": "/appointment",
    },
    {
        "id": 136,
        "name": "ADD_APPOINTMENTS",
        "slug": "Add Appointment",
        "route": "/appointment",
    },
    {
        "id": 137,
        "name": "CHANGE_APPOINTMENT_STATUS",
        "slug": "Change_Appointment_Status",
        "route": "/appointment/status",
    },
    {
        "id": 138,
        "name": "VIEW_BOOKING",
        "slug": "View Booking Schedule",
        "route": "/bookingschedule",
    },
    {
        "id": 139,
        "name": "ADD_BOOKING",
        "slug": "Add Booking Schedule",
        "route": "/bookingschedule",
    },
    {
        "id": 140,
        "name": "DELETE_BOOKING",
        "slug": "Delete Booking Schedule",
        "route": "/bookingschedule",
    },
    {
        "id": 141,
        "name": "VIEW_SETTINGS",
        "slug": "View Settings",
        "route": "/",
    },
    {
        "id": 142,
        "name": "VIEW_QUOTATIONS",
        "slug": "View Quotations",
        "route": "/quotations",
    },
    {
        "id": 143,
        "name": "SEND_EMAIL",
        "slug": "Send Mail",
        "route": "/send-email",
    },
    {
        "id": 144,
        "name": "VIEW_INVENTORY_REPORTS",
        "slug": "View Inventory Report",
        "route": "/inventory",
    },
    {
        "id": 145,
        "name": "VIEW_LOADED_DETAILS",
        "slug": "View Loaded Deatils",
        "route": "/details/{id}/booking",
    },
    {
        "id": 146,
        "name": "VIEW_VENDOR_QUOTATION",
        "slug": "View Vendor Quotation",
        "route": "/vendor_quotations",
    },
    {
        "id": 147,
        "name": "ADD_VENDOR_QUOTATION",
        "slug": "Add Vendor Quotation",
        "route": "/vendor_quotations/add",
    },
    {
        "id": 148,
        "name": "ADD_LOADPLAN_VENDORS",
        "slug": "Add Load plan Vendors",
        "route": "/",
    },
    {
        "id": 149,
        "name": "VIEW_OPERATION_DASHBOARD",
        "slug": "View Operations Dashboard",
        "route": "/operations_dashboard",
    },
    {
        "id": 150,
        "name": "VIEW_CUSTOMER_AJAX",
        "slug": "VIEW_DASHBOARD",
        "route": "/ajax/customers/list_ajax",
    },
    {
        "id": 151,
        "name": "ADD_IMO",
        "slug": "Generate IMO",
        "route": "/imo/{id}",
    },
    {
        "id": 152,
        "name": "VIEW_IMO",
        "slug": "View IMO",
        "route": "/imo_view/{id}",
    },
    {
        "id": 153,
        "name": "EDIT_IMO",
        "slug": "Edit IMO",
        "route": "/",
    },
    {
        "id": 154,
        "name": "DELETE_IMO",
        "slug": "Delete",
        "route": "",
    },
    {
        "id": 155,
        "name": "EDIT_INVOICE",
        "slug": "Edit Invoice",
        "route": "/invoices/{id}/edit",
    }
]

// Role 
export const ROLES = {
    ADMIN: "ADMIN",
    CUSTOMER: "CUSTOMER",
    EMPLOYEE: "EMPLOYEE",
    DRIVER: "DRIVER"
};
export const INVOICE_PAYMENT_STATUS = {
    PAID: 2,
    PARTIALLY_PAID: 1,
    UNPAID: 0
};
export const INVOICE_STATUS = {
    NOT_APPROVED: 0,
    APPROVED: 1
};
export const FEEDBACK_STATUS = {
    RESOLVED: "resolved",
    OPEN: "open",
};

export const ROLE = ["Trucker", "Customer"]
export const ADMIN = "admin";
export const MEMBER = "member";
export const CLIENT = "client";

// Vendor Details is_dg
export const DG = "DG"; //is_dg = 1
export const NON_DG = "NON-DG"; //is_dg = 0

// Opening Balance Account Types
export const acc_types = [
    "CAPITAL & LIABLITIES",
    "FIXED AND CURRENT ASSETS",
    "REVENUE AND EXPENSE ACCOUNT"
];

// Aws Base Folder Names
export const VEHICLES = "vehicles";
export const CONTAINERS = "containers";
export const APPOINTMENTS = "Appointments";

export const PERPAGE_OPTIONS = [10, 20, 50, 100];

const hostname = window.location.hostname;
export const COMPANY_LOGO = hostname.includes("portalsavannah") ? '/images/Savannah.png' : (hostname.includes("portalhouston") ? "/images/Houston.png" : "/images/Houston.png");
// "/images/New-York.png"